export const AdminNamespace = 'admin';
